import {pcDownloadFile} from '~/utils/files'

/**
 * Inventory Store
 *
 * @since 2018-08-09
 * @author Nanhyoung.Ro <dev014>
 */

// TAMS
const initSearchData = () => {
  return {
    request_id: '', // log 조회 아이디
    id: '', // 현재 다운로드 아이디
    // TAMS
    device_id: 0
  }
}

export const state = () => ({
  apiPreFix: '/api/lr/log/save/',
  apiDetailSave: '/api/lr/log/detail/save/',
  apiInfo: '/api/op/apt/setting',
  apiSaveFilePreFix: '/api/lr/log/audit/download',
  // ===  onSearch ===
  search: initSearchData(), // TAMS
  detail: {
    fileName: ''
  },
  searchState: {
    status: 'INIT', // 초기 단계: INIT, 추이 검색 중: SEARCHING_TREND_LOG, 로그 검색 중: SEARCHING_LOG, 검색 중지 요청 중: REQUEST_STOP, 로그 검색이 중지 됨: STOPPED, 로그 검색 완료: DONE
    progress: 0
  },
  mbas_info: {
    svr_type: '',
    svr_ip_type: '',
    apt_svr_ip: ''
  },
  logDetailDownErr: ''
})

export const mutations = {
  startCreateFile (state, data) {
    state.search.id = data.request_id
  },
  getCreateState (state, data) {
    state.searchState = data
  },
  setDetailDownErrMsg (state, data) {
    state.logDetailDownErr = data
  },
  endFileSave (state) {
    state.search.id = ''
  },
  // TAMS, search 데이터 초기화
  initStoreData (state) {
    state.search = initSearchData()
  }
}
export const actions = {
  // 로그 검색 start
  async startCreateFile ({commit, state}, param) {
    let res = { code: 'ok', result: {} } // TAMS
    let apiUrl = `${state.apiPreFix}${'start'}`
    try {
      let paramData = {}
      if (state.search.device_id !== 0) { // 현재 상태 보기 일 경우 (TAMS)
        apiUrl = `/api/lr/current/save/start`
        paramData = {
          device_id: state.search.device_id,
          request_id: state.search.request_id,
          row_count: param.row,
          column_key: param.key,
          column_name: param.value
        }
      } else {
        paramData = {
          request_id: state.search.request_id,
          column_key: param.key,
          column_name: param.value
        }
      }
      res = await this.$axios.$post(apiUrl, paramData, {successAlert: false})
      if (res.code === 'ok') {
        commit('startCreateFile', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 로그 검색 진행 상태 조회
  async getCreateState ({commit, state}) {
    let result = { code: 'ok', result: {} } // TAMS
    let apiUrl = `${state.apiPreFix}${state.search.id}${'/status'}`
    if (state.search.device_id !== 0) { // 현재 상태 보기 일 경우 (TAMS)
      apiUrl = `/api/lr/current/save/${state.search.device_id}/${state.search.id}/status`
    }
    try {
      result = await this.$axios.$get(apiUrl, {loading: false}) // TAMS
      if (result.code === 'ok') {
        commit('getCreateState', result.result)
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.result.msg = e.message
    }
    return result
  },
  async downloadFileSave ({commit, state, dispatch}, id) {
    const result = {}
    if (id === undefined) {
      result.code = 'nok'
      result.reason = 'request_id undefined'
      return result
    }
    let apiUrl = `${state.apiPreFix}${id}${'/download'}`
    if (state.search.device_id !== 0) { // 현재 상태 보기 일 경우 (TAMS)
      apiUrl = `/api/lr/current/save/${state.search.device_id}/${state.search.id}/download`
    }
    try {
      const result = await this.$axios.$file(encodeURI(apiUrl), {responseType: 'blob', loading: false, returnErr: true})

      if (result.code !== undefined) {
        const blob = new Blob([result.data])
        const reader = new FileReader()
        const _this = this
        reader.onload = () => {
          const msgObj = JSON.parse(reader.result)
          const msgTxt = msgObj.result.msg
          _this.$router.app.$alertPopUp.show(msgTxt)
        }
        reader.readAsText(blob)
      } else {
        pcDownloadFile(result.data, result.fileName)
        return ''
      }

      dispatch('endFileSave', id)

      result.code = 'ok'
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      return result
    }
  },
  async downloadDetailSave ({commit, state, dispatch}, { machId, logType, etime }) {
    const result = {}
    const fileName = state.detail.fileName
    let apiUrl = void 0
    // 위협 로그에서 요청시
    if (logType) apiUrl = `${state.apiDetailSave}${machId}/${logType}/${etime}/${fileName}`
    else apiUrl = `${state.apiDetailSave}${machId}/${fileName}`
    try {
      const result = await this.$axios.$file(encodeURI(apiUrl), {responseType: 'blob', successAlert: false, errorMsg: state.logDetailDownErr, returnErr: true})

      if (result.code !== undefined) {
        const blob = new Blob([result.data])
        const reader = new FileReader()
        const _this = this
        reader.onload = () => {
          const msgObj = JSON.parse(reader.result)
          const msgTxt = msgObj.result.msg
          _this.$router.app.$alertPopUp.show(msgTxt)
        }
        reader.readAsText(blob)
      } else {
        pcDownloadFile(result.data, result.fileName)
      }

      dispatch('endDownFileSave', {id: machId, fileName: result.fileName})

      result.code = 'ok'
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      return result
    }
  },
  // 기존 검색 끝!
  async endFileSave ({commit, state}, id) {
    let result = {}
    if (id === undefined || id === '') {
      result.code = 'nok'
      result.reason = 'request_id undefined'
      return result
    }
    const apiUrl = `${state.apiPreFix}${id}${'/end'}`
    try {
      result = await this.$axios.$delete(apiUrl, {data: {request_id: id}, loading: false, successAlert: false, errorAlert: false})
      commit('endFileSave', result.result)
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      return result
    }
  },
  // 기존 검색 끝!
  async endDownFileSave ({commit, state}, param) {
    let result = {}

    if (param.id === undefined || param.id === '') {
      result.code = 'nok'
      result.reason = 'request_id undefined'
      return result
    }
    const apiUrl = `${state.apiDetailSave}${param.id}/${param.fileName}${'/end'}`
    try {
      result = await this.$axios.$delete(apiUrl, {loading: false, successAlert: false, errorAlert: false})
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      return result
    }
  },
  // 로그 검색 진행 상태 조회
  async getMbasInfo ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiInfo}`
    try {
      result = await this.$axios.$get(apiUrl)
      if (result.code === 'ok') {
        const resD = result.result

        state.mbas_info = {
          svr_type: resD.svr_type,
          svr_ip_type: resD.svr_ip_type,
          apt_svr_ip: resD.apt_svr_ip
        }
        // commit('getCreateState', result.result)
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      return result
    }
  },
  async saveFile ({state}, sendParam) {
    const result = await this.$axios.$file(state.apiSaveFilePreFix, sendParam, {responseType: 'blob', successAlert: false, returnErr: true})

    if (result.code !== undefined) {
      const blob = new Blob([result.data])
      const reader = new FileReader()
      const _this = this
      reader.onload = () => {
        const msgObj = JSON.parse(reader.result)
        const msgTxt = msgObj.result.msg
        _this.$router.app.$alertPopUp.show(msgTxt)
      }
      reader.readAsText(blob)
    } else {
      pcDownloadFile(result.data, result.fileName)
      return ''
    }
  }
}

export const getters = {}
export const strict = false
